// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d1f22112","587":"e1429a41"}[chunkId] + ".chunk.js";
};